var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("date-filter", { staticClass: "date-options with-picker" }),
      _c("date-range-picker", {
        attrs: {
          start: _vm.startDate,
          end: _vm.endDate,
          picker: _vm.picker,
          position: "is-bottom-left",
        },
        on: { apply: _vm.setReportDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }